import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Main from "../components/Main";
import FooterSection from "../components/FooterSection";
import NumberCount from "../components/NumberCount";

export default function Home() {
  return (
    <div>
      <Header />
      <Hero />
      <Main />
      <NumberCount />
      <FooterSection />
    </div>
  );
}
  